import { render } from "./index.vue?vue&type=template&id=93827c42&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=93827c42&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93827c42"]])

export default __exports__